import Reveal from "@/components/Reveal";
import ChipGroup from "@/components/funding/Chips";

/** Funder pathway: interest + contribution selectors that feed the enquiry form. */
const FunderPathway = ({ content, interests, contributions, onToggleInterest, onToggleContribution, onEnquire }) => (
  <div>
    <Reveal>
      <h2 className="font-serif text-3xl md:text-4xl tracking-tight leading-snug text-charcoal max-w-2xl" data-testid="funder-pathway-heading">
        {content.heading}
      </h2>
    </Reveal>

    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-10">
      <Reveal>
        <h3 className="text-xs uppercase tracking-[0.15em] text-ochre-dark mb-4">{content.interestsLabel}</h3>
        <ChipGroup
          options={content.interests}
          selected={interests}
          onToggle={onToggleInterest}
          testIdPrefix="funder-interest"
          ariaLabel="Areas of interest"
        />
      </Reveal>
      <Reveal delay={0.05}>
        <h3 className="text-xs uppercase tracking-[0.15em] text-ochre-dark mb-4">{content.contributionsLabel}</h3>
        <ChipGroup
          options={content.contributions}
          selected={contributions}
          onToggle={onToggleContribution}
          testIdPrefix="funder-contribution"
          ariaLabel="Types of contribution"
        />
      </Reveal>
    </div>

    <Reveal className="mt-10">
      <p className="text-base md:text-lg leading-relaxed text-charcoal/90 max-w-2xl">{content.body}</p>
      <p className="mt-3 text-sm text-charcoal/60 max-w-2xl">{content.note}</p>
      <button
        type="button"
        data-testid="funder-pathway-enquiry-button"
        onClick={onEnquire}
        className="mt-8 bg-eucalyptus text-cream px-7 py-3.5 rounded-sm text-sm tracking-wide hover:bg-eucalyptus-deep transition-colors duration-300"
      >
        {content.button}
      </button>
    </Reveal>
  </div>
);

export default FunderPathway;
